import { nonEmptyArray as NEA, option as O } from "fp-ts";
import { pipe } from "fp-ts/lib/function";
import type {
  PDPSwarovskiProductFrontend,
  PDPSwarovskiProductVariantFrontend,
} from "./PDP_SingleImageCarousel/state/types";
import { getAttributes } from "./getAttributes";
import { computeTechSpecsAttributes } from "./computeTechSpecsAttributes";

export function getAdditionalPdpData(
  selectedProduct: PDPSwarovskiProductFrontend,
  selectedVariant: PDPSwarovskiProductVariantFrontend,
  translations: {
    yesLabel: string;
    noLabel: string;
  },
  countryIsoCode: string,
) {
  const attributes = getAttributes(selectedVariant);
  const techSpecsAttributes = computeTechSpecsAttributes(attributes, translations, countryIsoCode).slice(0, 4);

  const deliveryPackageProps = pipe(
    selectedVariant.deliveryPackage,
    O.fromNullable,
    O.chain(dp => NEA.fromArray(dp)),
    O.alt(() => O.fromNullable(selectedProduct.deliveryPackage)),
    O.chain(deliveryPackage => NEA.fromArray(deliveryPackage)),
    O.toUndefined,
  );

  const longDescription = selectedVariant.longDescription || selectedProduct.longDescription;

  return { techSpecsAttributes, deliveryPackageProps, longDescription };
}
